import React, {useContext} from 'react';
import { HeadContext } from '../../Provider';
import Masonry from '../Grid';
import { Button } from '../Button';
import Loader from '../Loader';
import ObraServices, {iObra,iFuncion, iPeriodo, iFormSearch} from '../../Services/ObraServices';
import './index.scss';

interface iProps {
    handleClose?: () => void;
    handleLoadMore: ()=> void;
    list: iObra[];
    isLoading: boolean;
    notFound: boolean;
    className?: string;
}

export default (props:iProps) => {

    const context = useContext(HeadContext);

    function hideSearch () {
        context.setShowSearch(false)
    }
    return (
        <div className={`c_working_list ${props.className}`}>
            {props.list.length > 0 ?
                <>
                    <Masonry collection={props.list} handleClickWork={()=> {hideSearch()}}></Masonry>
                    {!props.notFound ?
                        <Button isLoading={props.isLoading} action={()=>{props.handleLoadMore()}} className="c_working_list__load_more" theme="solid">Ver Mas</Button>
                        :
                        <p className={'e-h6'}>No se encontraron mas resultados</p>
                    }
                </>
                :
                <>
                {props.isLoading && <Loader/>}
                {props.notFound && <p className={'e-h3'}>Lo sentimos, no encontramos resultados.</p>}
                </>
            }
        </div>
    )
}